import React from 'react';
import { Calendar } from 'lucide-react';

export const PresentationTab = ({ active, label, onClick, testId }) => (
  <button
    onClick={onClick}
    data-testid={testId}
    className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
      active
        ? 'bg-brand-primary text-text-inverse'
        : 'bg-bg-page text-text-secondary border border-border-medium hover:border-brand-primary'
    }`}
  >
    <div className="flex items-center gap-2">
      <Calendar className="w-4 h-4" />
      <span>{label}</span>
    </div>
  </button>
);
